import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { CATEGORY, CATEGORY_ADD, CATEGORY_DELETE } from "./actionTypes";
import {
  apiError,
  getCategorys,
  CategoryListSuccessful,
  CategoryAddSuccessful,
} from "./actions";

// AUTH related methods
import {
  postAdd,
  getList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getCategory() {
  try {
    const response = yield call(getList, "/masters/categorys/", {});
    yield put(CategoryListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

//If user is login then dispatch redux action's are directly from here.
function* AddCategory({ payload: { category } }) {
  try {
    if (category.id === "") {
      const response = yield call(postAdd, "/masters/categorys/", {
        name: category.name,
      });
      if (response.status === 201) {
        swal("Your Category Added Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getCategorys());
      } else {
        swal("Sorry! Unable to add Category. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(CategoryAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/categorys/" + category.id,
        {
          name: category.name,
        }
      );
      if (response.status === 200) {
        swal("Your Category Edited Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getCategorys());
      } else {
        swal("Sorry! Unable to edit Category. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(CategoryAddSuccessful(null));
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });
  }
}

//If user is login then dispatch redux action's are directly from here.
function* DeleteCategory(CTAId) {
  try {
    const response = yield call(
      postDelete,
      "/masters/categorys/" + CTAId.payload.CTAId
    );
    if (response.status === 204) {
      swal("Your Category has been deleted!", {
        icon: "success",
        timer: 1500,
      });
      yield put(getCategorys());
    } else {
      swal("Sorry! Your Category has been not deleted!", {
        icon: "error",
      });
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}

export function* watchgetCategory() {
  yield takeEvery(CATEGORY, getCategory);
}
export function* watchCategoryAdd() {
  yield takeEvery(CATEGORY_ADD, AddCategory);
}

export function* watchCategoryDelete() {
  yield takeEvery(CATEGORY_DELETE, DeleteCategory);
}

function* CategorySaga() {
  yield all([
    fork(watchgetCategory),
    fork(watchCategoryAdd),
    fork(watchCategoryDelete),
  ]);
}

export default CategorySaga;
